import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CommonPostResponse } from '../../../components/models/models'
import { IAkOdePosInsatallment } from '../models/models'

export class UpdateAkOdePosInsatallmentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransactionAkOde/updateAkOdePosInsatallment',
      requesterInfo,
    })
  }

  public async updateAkOdePosInsatallment(request: IAkOdePosInsatallment): Promise<CommonPostResponse> {
    return await this.postAsync<CommonPostResponse>(request)
  }
}

